import React from 'react'
import styles from './ScoopText.module.scss'

/**
 * ScoopText - A flexible text component
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Text content
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.as='span'] - HTML element to render (span, p, div, etc.)
 * @param {string} [props.variant] - Semantic variant: 'label' | 'body' | 'caption' | 'title' | 'subtitle'
 * @param {string} [props.size] - Font size: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
 * @param {string} [props.weight] - Font weight: 'regular' | 'medium' | 'semibold' | 'bold'
 * @param {string} [props.color] - Text color: 'primary' | 'secondary' | 'muted' | 'error' | 'success'
 */
export const ScoopText = ({
    children,
    className,
    as = 'span',
    variant,
    size,
    weight,
    color,
    ...props
}) => {
    const Component = as

    const textClassName = [
        styles.text,
        variant && styles[`variant-${variant}`],
        size && styles[`size-${size}`],
        weight && styles[`weight-${weight}`],
        color && styles[`color-${color}`],
        className,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <Component className={textClassName} {...props}>
            {children}
        </Component>
    )
}
